import { isDefined } from 'remeda';
import { IWeddingEvent } from '@bridebook/models/source/models/Weddings/Events.types';
import { GetWeddingWebsiteDataResponseSuccess } from '@bridebook/web/pages/api/for/website/[websiteId]';
import { IEnrichedEvent } from '@bridebook/web/components/wedding-website/guest-rsvp/guest-rsvp.context';
import { compareEventsDateTime } from '@bridebook/web/lib/events/sort-unified-events';
import { isPrimaryVenueSection } from '@bridebook/web/lib/wedding-website/utils/sections-typeguards';
import {
  DATE_FORMAT,
  dateFromIDatePicker,
  format,
} from '@bridebook/web/lib/time-date-manipulation/time-date-manipulation';

/**
 * Combines guest invitation event IDs with website event data to produce
 * enriched events (with supplier info and formatted dates) for the RSVP flow.
 *
 * RSVP-specific: filters by invited events, works with API response data
 * (not Redux), and wraps results in IEnrichedEvent.
 */
export const getEnrichedEvents = (
  invitedEventIds: string[],
  weddingWebsite: GetWeddingWebsiteDataResponseSuccess,
  events: IWeddingEvent[] = weddingWebsite.events,
): IEnrichedEvent[] =>
  invitedEventIds
    .map((eventId) => {
      const eventData = events.find((event) => event.id === eventId);

      if (!eventData) return undefined;

      if (eventData.type === 'MainEvent') {
        const venueSection = weddingWebsite.website?.sections.find(isPrimaryVenueSection);
        const mainSupplierId = venueSection?.data.supplier;

        return {
          data: {
            ...eventData,
            date: weddingWebsite.wedding.date
              ? format(
                  dateFromIDatePicker(weddingWebsite.wedding.date) || new Date(),
                  DATE_FORMAT.DATE.ISO,
                )
              : '',
          },
          supplier: weddingWebsite.suppliers.find((s) => s.id === mainSupplierId),
          eventId,
        };
      }

      return {
        data: eventData,
        supplier: weddingWebsite.suppliers.find((s) => s.id === eventData.supplier),
        eventId,
      };
    })
    .filter(isDefined)
    .sort((a, b) => compareEventsDateTime(a.data, b.data));
